import { useEffect, useState } from 'react';

import './ajustes.css';

export interface DepsDoDiagnostico {
  estimativa: () => Promise<{
    usado: number;
    cota: number;
    persistido: boolean;
  } | null>;
  emStandalone: () => boolean;
  versao: string;
}

function mb(bytes: number): string {
  return `${(bytes / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} MB`;
}

export function Diagnostico({ deps }: { deps: DepsDoDiagnostico }) {
  const [e, setE] = useState<
    Awaited<ReturnType<DepsDoDiagnostico['estimativa']>> | undefined
  >(undefined);
  useEffect(() => {
    void deps.estimativa().then(setE);
  }, [deps]);
  return (
    <section className="ajustes__secao" aria-labelledby="diag">
      <h2 id="diag">Diagnóstico</h2>
      <ul>
        <li>
          Armazenamento persistente:{' '}
          {e === undefined
            ? '…'
            : e === null
              ? 'indisponível'
              : e.persistido
                ? 'sim'
                : 'não'}
        </li>
        <li>Espaço usado: {e ? `${mb(e.usado)} de ${mb(e.cota)}` : '…'}</li>
        <li>
          Instalado na Tela de Início: {deps.emStandalone() ? 'sim' : 'não'}
        </li>
        <li>Versão: {deps.versao}</li>
      </ul>
    </section>
  );
}
